var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.05 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #e2b700;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #e2b721;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.4,36.5l-.29-4.95h-1.59c-4.18,0-7.73-1.46-10.65-4.38-2.92-2.92-4.38-6.47-4.38-10.65s1.46-7.73,4.38-10.65C8.8,2.96,12.35,1.5,16.53,1.5c2.09,0,4.04,.39,5.86,1.17,1.82,.78,3.41,1.85,4.77,3.22,1.37,1.37,2.44,2.96,3.22,4.77,.78,1.82,1.17,3.77,1.17,5.86s-.33,4.18-1,6.14c-.66,1.96-1.58,3.8-2.74,5.5-1.16,1.71-2.55,3.27-4.16,4.68-1.61,1.41-3.36,2.63-5.26,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.5,25.4c.37,0,.69-.13,.94-.39s.39-.57,.39-.94-.13-.69-.39-.94-.57-.39-.94-.39c-.37,0-.69,.13-.94,.39s-.39,.57-.39,.94,.13,.69,.39,.94,.57,.39,.94,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.49,20.7c.02-.75,.13-1.31,.32-1.67,.19-.36,.71-.97,1.56-1.82,.48-.48,.88-1,1.18-1.53,.3-.54,.46-1.13,.46-1.78,0-1.3-.44-2.29-1.33-2.98-.89-.69-1.94-1.04-3.17-1.04-1.12,0-2.06,.31-2.82,.92-.77,.62-1.32,1.36-1.65,2.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.87b943bc5e97412c90fe8e02a164056b.svg";
export { ForwardRef as ReactComponent };